<header class="emdm-header">
  <div class="nav">
    <div class="nav-logo">
      <a class="logo-title" href="/">
        <img class="app-logo" alt="Chevron Logo" src="../../assets/images/ChevronLogo.png" />
        <div class="title">EMDM</div>
      </a>

      <!-- <nav class="custom-navbar" *ngIf="userIsActive"> -->
      <div class="custom-navbar" *ngIf="userIsActive">
        <a class="navbar-item" [ngClass]="{'active': activeMenu.toLowerCase() == 'dashboard'}"
          (click)="activeMenu = 'dashboard'" routerLink="/dashboard">
          Dashboard
      </a>

        <a class="navbar-item" [ngClass]="{'active': activeMenu.toLowerCase() == 'dataconsole'}" target="_self"
          (click)="activeMenu = 'dataconsole'" routerLink="/DataConsole"> Data Console </a>

        <a class="navbar-item" [ngClass]="{'active': activeMenu.toLowerCase() == 'reporting-dashboard'}"
          (click)="activeMenu = 'Reporting-Dashboard'" routerLink="/Reporting-Dashboard">
          Reporting Dashboard
    </a>

        <a class="navbar-item" [ngClass]="{'active': activeMenu.toLowerCase() == 'user-manager'}"
          (click)="activeMenu = 'user-manager'" routerLink="/user-manager" *ngIf="isSpecialist">
          User Manager
  </a>
      </div>
      <!-- </nav> -->
    </div>


    <div class="profile">
      <div class="profile-name">
        <span>{{welcomeName}}</span>
      </div>
      <div class="logout-icon" (click)="logout()">
        <fa-icon [icon]="faLogout" class="Login_Out_Buttons"></fa-icon>
      </div>
    </div>

    <div class="kebab-menu" id="kebab-menu" *ngIf="userIsActive">
      <button class="menu-button" (click)="toggleMenu($event)">&#x22EE;</button>
      <div class="menu-content" [ngClass]="{'show': menuOpen}">
        <div>
          <fa-icon [icon]="iconPacks.FACLOSE" (click)="menuOpen = false" class="popupCLoseIcon">
          </fa-icon>
        </div>
        <div class="custom-navbar-mobile">
          <div class="navbar-item-mobile" [ngClass]="{'active': activeMenu.toLowerCase() == 'dashboard'}"
            (click)="activeMenu = 'dashboard'" routerLink="/dashboard">
            Dashboard
          </div>

          <div class="navbar-item-mobile" [ngClass]="{'active': activeMenu.toLowerCase() == 'dataconsole'}"
            (click)="activeMenu = 'dataconsole'" routerLink="/DataConsole"> Data Console </div>

          <div class="navbar-item-mobile" [ngClass]="{'active': activeMenu.toLowerCase() == 'reporting-dashboard'}"
            (click)="activeMenu = 'Reporting-Dashboard'" routerLink="/Reporting-Dashboard">
            Reporting Dashboard
          </div>

          <div class="navbar-item-mobile" [ngClass]="{'active': activeMenu.toLowerCase() == 'user-manager'}"
            (click)="activeMenu = 'user-manager'" routerLink="/user-manager" *ngIf="isSpecialist">
            User Manager
          </div>
        </div>

        <div class="profile-mobile">
          <div class="profile-name">
            <span>{{welcomeName}}</span>
          </div>
          <div class="logout-icon" (click)="logout()">
            <fa-icon [icon]="faLogout" class="Login_Out_Buttons"></fa-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>